import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, Table, Alert
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import moment from 'moment'
import Shimmer from "react-shimmer-effect";

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'
import DatePicker from '../../../../../helpers/ui/DatePicker'
import InfoComponents from './Components/InfoComponents'
import { addDays } from 'date-fns';
class CreateView extends Component {

    source
    createBloc = new CreateBloc();
    indexBloc = new IndexBloc()
    timer
    queryParams = new URLSearchParams(window.location.search)

    // Array Status Pegawai yang Dapat Cuti Tahunan
    allowed = ['PNS', 'CPNS', 'Honorer', 'INTERNAL » PNS', 'INTERNAL » CPNS', 'INTERNAL » HONORER', 'INTERNAL » PPPK'];
    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "")
        : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "")
        : (this.employeeSeleted != null ? this.employeeSeleted : "")

    currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    constructor(props) {
        super(props)
        var hari_libur = [];
        var storage_libur = sessionStorage.getItem('holidays') ? JSON.parse(sessionStorage.getItem('holidays')) : [];
        storage_libur.map(function (item, i) {
            var libur = addDays(new Date(item), 0);// moment(item).format("DD/MM/YYYY");
            hari_libur.push(libur);
        });
        this.state = {
            failedInfo: "Terjadi Kesalahan Mohon Hubungi Bagian Admin!",
            typeOption: [],
            childTypeOption: [],
            selectedType: '',
            is_required_file_upload: false,
            kuota: [],
            listCuti: [],
            startDate: null,
            maxDate: null,
            endDate: null,
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc'
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc'
                }
            },
            minDateLoading: false,
            minDateAwal: "",
            minDateSelesai: "",
            maxDateSelesai: "",
            start_date_min: "",
            end_date_min: "",
            end_date_max: "",
            paid_leave_type_loading: true,
            childTypeLoading: false,
            sisa_cuti: 0,
            quotaList: [],
            holidays: sessionStorage.getItem('holidays') ? JSON.parse(sessionStorage.getItem('holidays')) : [],
            holidays_format_date: hari_libur,
            is_revisi: this.queryParams.get('is_revisi'),
            revisi_pegawai_uuid: this.queryParams.get('pegawai_uuid'),
            period_revision_uuid: this.queryParams.get('period_revision_uuid')
        }
        //console.log(this.state.holidays);
        //console.log(this.state.holidays_format_date);
        //console.log([addDays(new Date("2023-03-23"), 0), addDays(new Date("2023-03-24"), 0)])
    }

    getSisaCuti = () => {
        // let sisaCutiTahunIni = 0;
        // if (this.state.kuota) {
        //     let sisaCuti = 0;
        //     sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
        //     if (sisaCuti > 6) {
        //         sisaCuti = 6
        //     }
        //     sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
        // }

        // return sisaCutiTahunIni;

        return this.state.sisa_cuti;
    }

    handleTypeCuti = (v) => {
        if (v == 'b490a04a-0362-489b-832a-29e4c3b961bc') { // cuti tahunan
            this.loadMindate({ nip: this.peg_detail.employee_nip, amount: (this.getSisaCuti()), jenis: v })
            // console.log(moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD'), sisaCutiTahunIni)
            // this.setState({
            //     minDate: moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD')
            // })
        } else if (v == '5a0b8444-74a6-4228-9c4c-1431a61eedbc') { // cuti bersalin
            this.loadMindate({ nip: this.peg_detail.employee_nip, amount: (90), jenis: v })
            // console.log(moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD'), sisaCutiTahunIni)
            // this.setState({
            //     minDate: moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD')
            // })
        } else {
            // this.setState({
            //     minDate: ""
            // })
            this.loadMindate({ nip: this.peg_detail.employee_nip, amount: (0), jenis: v })
        }
        if (v == 'e1ec1835-6a27-4831-91f9-5b68a7b11de2' || v == '5a0b8444-74a6-4228-9c4c-1431a61eedbc' || v == '47b76ad9-0ccd-493c-8fb0-57d7aee48a80') {
            this.setState({
                is_required_file_upload: true
            })
        } else {
            this.setState({
                is_required_file_upload: false
            })
        }
    }

    handleTanggalCuti = (v) => {
        //console.log(this.state.selectedType)
        if (this.state.selectedType == 'b490a04a-0362-489b-832a-29e4c3b961bc') { // cuti tahunan
            this.loadMindate({ nip: this.peg_detail.employee_nip, date: v, amount: (this.getSisaCuti()), jenis: this.state.selectedType })
        } else if (this.state.selectedType == '5a0b8444-74a6-4228-9c4c-1431a61eedbc') { // cuti bersalin
            this.loadMindate({ nip: this.peg_detail.employee_nip, date: v, amount: 90, jenis: this.state.selectedType })
        } else {
            this.loadMindate({ nip: this.peg_detail.employee_nip, date: v, amount: (0), jenis: this.state.selectedType })
        }
    }

    loadMindate = (query) => {
        this.setState({
            minDateLoading: true,
            minDateAwal: null,
            minDateSelesai: null,
            maxDateSelesai: null,
            start_date_min: query.date ? this.state.start_date_min : null,
            end_date_min: null,
            end_date_max: null,
        });
        this.createBloc.fetchMinDate(query);
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        if (this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc') {
            if (this.state.listCuti?.length > this.getSisaCuti()) {
                alert('Total pengajuan cuti melebihi kuota cuti anda, mohon disesuaikan!')
                return;
            }
        }


        this.setState({
            dataForm: {
                paid_leave_employee_uuid: this.peg_uuid,
                access_id: this.currentRoleId,
                is_revisi: this.state.is_revisi,
                period_revision_uuid: this.state.period_revision_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'document')
        await this.createBloc.fetchCreate(dataForm)
    }


    checkDate = () => {
        this.createBloc.fetchCheckDate({
            employee_uuid: this.peg_detail.employee_uuid,
            start_date: this.state.startDate,
            end_date: this.state.endDate
        })
    }

    confirmResponse = (response) => {
        let forState = {}

        if (this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc') {
            let sisaCutiTahunIni = 0;
            if (this.state.kuota) {
                let sisaCuti = 0;
                sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
                if (sisaCuti > 6) {
                    sisaCuti = 6
                }
                sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
                sisaCutiTahunIni = sisaCutiTahunIni - this.state.listCuti?.length
                if (sisaCutiTahunIni < 0) {
                    response = 'cancel'
                }
            }
        }
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.submitData()
                this.checkDate()

                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number - 1) * this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number - 1) * this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadChildTypeList = async () => {
        const query = {
            parent: this.state.selectedType
        }
        this.setState({ childTypeLoading: true, childTypeOption: [] })
        await this.indexBloc.fetchChildTypeList(query, this.source.token)
    }

    loadKuota = async () => {
        await this.indexBloc.fetchKuotaTahunan({ uuid: this.peg_uuid })
    }

    setTokenAPI = () => {
        //console.log(this.queryParams.get('is_revisi'))
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadKuota()
        this.loadTypeList()
        this.loadSignatoriesList()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    dateChange = () => {
        this.setState({ listCuti: new Array() })
        const { startDate, endDate, selectedType } = this.state


        // console.log(selectedType)

        console.log(selectedType)
        if (selectedType != '22ba90f5-23c3-4ac1-8bad-e7d1cb7ed490' && selectedType != '5a0b8444-74a6-4228-9c4c-1431a61eedbc') {
            if (startDate != null && endDate != null) {
                var startDateX = new Date(startDate); //YYYY-MM-DD
                var endDateX = new Date(endDate); //YYYY-MM-DD
                var holiday = this.state.holidays_format_date;

                var getDateArray = function (start, end) {
                    var arr = new Array();
                    var dt = new Date(start);

                    while (dt <= end) {
                        arr.push(new Date(dt));
                        dt.setDate(dt.getDate() + 1);

                    }
                    return arr;
                }
                var dateArr = getDateArray(startDateX, endDateX);
                dateArr.map(function (tgl) {
                    holiday.map(function (libur) {
                        if (tgl.toString() === libur.toString()) {
                            dateArr = dateArr.filter(function (e) { return e.toString() !== tgl.toString() })
                        }


                    })
                    if (tgl.getDay() == 6 || tgl.getDay() == 0) {
                        dateArr = dateArr.filter(function (e) { return e.toString() !== tgl.toString() })
                    }
                })
                this.setState({ listCuti: dateArr });

            }
        } else {
            if (startDate != null && endDate != null) {
                var startDateX = new Date(startDate); //YYYY-MM-DD
                var endDateX = new Date(endDate); //YYYY-MM-DD
                var holiday = this.state.holidays_format_date;

                var getDateArray = function (start, end) {
                    var arr = new Array();
                    var dt = new Date(start);

                    while (dt <= end) {
                        arr.push(new Date(dt));
                        dt.setDate(dt.getDate() + 1);

                    }
                    return arr;
                }
                var dateArr = getDateArray(startDateX, endDateX);
                this.setState({ listCuti: dateArr });

            }
        }
    }

    componentDidMount = () => {

        this.setTokenAPI()

        this.indexBloc.kuotaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    if (response) {
                        this.setState({
                            quotaList: response.list,
                            sisa_cuti: response.sisa
                        });
                        //console.log('xxx '+((this.state.quotaList.length)-1))
                    }
                    // this.setState({ kuota: result.data.response })

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    // console.log(this.peg_detail.employee_categories_name_full)
                    // if (!this.allowed.includes(this.peg_detail.employee_categories_name_full)) {
                    //     type = type.filter(function (el) {
                    //         return el.paid_leave_type_uuid != 'b490a04a-0362-489b-832a-29e4c3b961bc' // CUTI TAHUNAN
                    //     });
                    // }
                    const pppkRestrictedTypes = [
                        '47b76ad9-0ccd-493c-8fb0-57d7aee48a80', // Cuti Alasan Penting
                        '22ba90f5-23c3-4ac1-8bad-e7d1cb7ed490'  // Cuti Besar
                    ];
                    if (this.peg_detail.employee_categories_name_full === 'INTERNAL » PPPK') {
                        type = type.filter(function (el) {
                            return !pppkRestrictedTypes.includes(el.paid_leave_type_uuid)
                        });
                    }

                    this.setState({
                        typeOption: type,
                        paid_leave_type_loading: false
                    })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.childTypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    this.setState({ childTypeOption: type, childTypeLoading: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({
                        atasan: response.atasan,
                        jabatan: response.jabatan,
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        failedInfo: result.data.message
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.minDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        minDateLoading: false,
                        minDateAwal: result.data.response.min_stdate_mulai,
                        minDateSelesai: result.data.response.min_stdate_selesai,
                        maxDateSelesai: result.data.response.max_stdate,
                        start_date_min: result.data.response.new_result.start_date_min,
                        end_date_min: result.data.response.new_result.end_date_min,
                        end_date_max: result.data.response.new_result.end_date_max,
                    })
                    //console.log('start_date_min '+result.data.response.new_result.start_date_min)
                    //console.log('max_stdate '+result.data.response.max_stdate)
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        minDateLoading: false
                    });
                    break;
                default:
                    break;
            }
        })

        this.createBloc.checkDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({
                        count_used_date: response.count_used_date,
                        pl_date: response.pl_date,
                        ot_date: response.ot_date,
                        newHtml: response.newHtml,
                    })

                    if (response.count_used_date == 0) {
                        this.submitData()
                    } else {
                        this.setState({
                            failedInfo: response.message,
                            loading: false,
                            failed: true,
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })


    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.startDate !== this.state.startDate) {
            this.dateChange()
        }
        if (prevState.endDate !== this.state.endDate) {
            this.dateChange()
        }
        if (prevState.selectedType !== this.state.selectedType) {
            this.dateChange()
            this.loadChildTypeList()
        }
    }

    componentWillUnmount = () => {
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.kuotaChannel?.unsubscribe()
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.minDateChannel?.unsubscribe()
        this.createBloc.checkDateChannel?.unsubscribe()
    }

    render() {
        let sisaCutiTahunIni = this.state.sisa_cuti;
        // if (this.state.kuota) {
        //     let sisaCuti = 0;
        //     sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
        //     if (sisaCuti > 6) {
        //         sisaCuti = 6
        //     }
        //     sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
        //     if (sisaCutiTahunIni < 0) {
        //         sisaCutiTahunIni = 0
        //     }
        // }
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        {
                                            this.state.is_revisi == 1 ?
                                                <Link to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid}>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                                :
                                                <Link to={`/izinpegawai/cuti.html${(this.currentRoleId == 1 ? '?detail_pegawai&uuid=' + this.peg_uuid : '')}`}>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                        }

                                    </div>
                                    <CardTitle>Pengajuan Cutixx</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Pegawai
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="paid_leave_employee_name"
                                                    placeholder="Masukkan Pegawai"
                                                    errorMessage="Masukkan Pegawai"
                                                    type="text"
                                                    readOnly={true}
                                                    className="form-control"
                                                    value={this.peg_detail.employee_full_name}
                                                // validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <Select
                                                    name="paid_leave_type_uuid"
                                                    errorMessage="Pilih Jenis Cuti"
                                                    options={this.state.typeOption}
                                                    optionLabel="paid_leave_type_name"
                                                    optionValue="paid_leave_type_uuid"
                                                    placeholder="Pilih Jenis Cuti"
                                                    onChange={opt => {
                                                        this.setState({ selectedType: opt.paid_leave_type_uuid })
                                                        this.handleTypeCuti(opt.paid_leave_type_uuid)
                                                    }}
                                                    validate={{ required: { value: true } }}
                                                    isLoading={this.state.paid_leave_type_loading}
                                                />
                                            </Col>
                                        </Row>

                                        {this.state.selectedType !== '' && this.state.childTypeOption?.length > 0 ?
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Detail Jenis Cuti <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3">
                                                    <Select
                                                        name="paid_leave_type_detail_uuid"
                                                        errorMessage="Pilih Detail Jenis Cuti"
                                                        options={this.state.childTypeOption}
                                                        optionLabel="paid_leave_type_detail_name"
                                                        optionValue="paid_leave_type_detail_uuid"
                                                        placeholder="Pilih Detail Jenis Cuti"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>
                                            :
                                            this.state.childTypeLoading ?
                                                <Row className="mb-3">
                                                    <Col md={2}>
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                :
                                                ""
                                        }

                                        {
                                            this.state.selectedType != '' && this.state.selectedType != '9e56930f-4643-4547-a427-ebb6fa3330f1' ?
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Informasi Cuti
                                                    </Label>
                                                    <Col md={8}>
                                                        <InfoComponents uuid={this.state.selectedType} />
                                                    </Col>
                                                </Row>
                                                : ""
                                        }

                                        {this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc' &&
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Informasi Sisa Cuti Tahunan
                                                    </Label>
                                                    <Col md="3">
                                                        <Table className='table table-striped table-bordered table-hover'>
                                                            <thead>
                                                                <tr>
                                                                    <th className='text-center'>Tahun</th>
                                                                    <th className='text-center'>Digunakan</th>
                                                                    <th className='text-center'>Sisa</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.quotaList.map((item, key) => {
                                                                        return (
                                                                            <tr>
                                                                                <td className='text-center'>{item.tahun}</td>
                                                                                <td className='text-center'>{item.digunakan}</td>
                                                                                <td className='text-center'>{item.saldo_cuti}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                <tr>
                                                                    <th colSpan={2} className='text-center'>Saldo</th>
                                                                    <td className='text-center'>
                                                                        <b>{sisaCutiTahunIni}</b> dari ({this.state.quotaList[((this.state.quotaList.length) - 1)]?.total_saldo_cuti})

                                                                        {/* <b>{sisaCutiTahunIni}</b> dari ({this.state.quotaList[((this.state.quotaList.length) - 1)].total_saldo_cuti}) */}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                {/* <AvField
                                                    name="paid_leave_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    onChange={e => { 
                                                        this.setState({ startDate: e.target.value });
                                                        this.handleTanggalCuti(e.target.value)
                                                    }}
                                                    validate={{ required: { value: true } }}
                                                    min={this.state.minDateAwal}
                                                /> */}

                                                {
                                                    this.state.childTypeLoading ?
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                        :
                                                        this.currentRoleId == 1 ? // admin tidak dibatasi
                                                            <DatePicker
                                                                name="paid_leave_start_date"
                                                                isWeekday={true}
                                                                dateFormat="dd/MM/yyyy"
                                                                placeholder="Tanggal Mulai"
                                                                excludeDates={this.state.holidays_format_date}
                                                                errorMessage="Masukan Tanggal Mulai"
                                                                validate={{ required: { value: true } }}
                                                                defaultValue={this.state.startDate}
                                                                onChange={e => {
                                                                    this.setState({ startDate: moment(e).format('YYYY-MM-DD') });
                                                                    this.handleTanggalCuti(moment(e).format('YYYY-MM-DD'))
                                                                    //console.log('Mulai : ' + moment(e).format('YYYY-MM-DD'))
                                                                }}
                                                            />
                                                            :
                                                            <DatePicker
                                                                name="paid_leave_start_date"
                                                                isWeekday={true}
                                                                dateFormat="dd/MM/yyyy"
                                                                placeholder="Tanggal Mulai"
                                                                errorMessage="Masukan Tanggal Mulai"
                                                                excludeDates={this.state.holidays_format_date}
                                                                validate={{ required: { value: true } }}
                                                                minDate={this.state.start_date_min}
                                                                defaultValue={this.state.startDate}
                                                                //excludeDates={[addDays(new Date("2023-03-23"), 0), addDays(new Date("2023-03-24"), 0)]} 
                                                                //excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5), addDays(new Date(), 7), addDays(new Date(), 12) ]}
                                                                onChange={e => {
                                                                    this.setState({ startDate: moment(e).format('YYYY-MM-DD') });
                                                                    this.handleTanggalCuti(moment(e).format('YYYY-MM-DD'))
                                                                    // console.log([addDays(new Date("2023-03-23"), 0), addDays(new Date("2023-03-24"), 0)])
                                                                    //console.log('Mulai : ' + moment(e).format('YYYY-MM-DD'))
                                                                    //var maxdate = new Date(e.getTime()+3*24*60*60*1000);
                                                                    //this.setState({ startDate: moment(e).format('YYYY-MM-DD'),maxDate: moment(maxdate).format('YYYY-MM-DD') });
                                                                    //this.handleTanggalCuti(moment(e).format('YYYY-MM-DD'))

                                                                }}
                                                            //minDate={this.state.minDateAwal}
                                                            />
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Cuti<span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                {
                                                    this.state.childTypeLoading || this.state.minDateLoading ?
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                        :
                                                        this.currentRoleId == 1 ? // admin tidak dibatasi
                                                            <DatePicker
                                                                name="paid_leave_end_date"
                                                                isWeekday={true}
                                                                dateFormat="dd/MM/yyyy"
                                                                placeholder="Tanggal Selesai"
                                                                errorMessage="Masukan Tanggal Selesai"
                                                                excludeDates={this.state.holidays_format_date}
                                                                validate={{ required: { value: true } }}
                                                                defaultValue={this.state.endDate}
                                                                onChange={e => {
                                                                    this.setState({ endDate: moment(e).format('YYYY-MM-DD') });
                                                                    //console.log('Selesai : ' + moment(e).format('YYYY-MM-DD'))
                                                                }}
                                                                maxDate={this.state.end_date_max}
                                                             // minDate={this.state.minDateSelesai}
                                                             // maxDate={this.state.maxDateSelesai}
                                                             />
                                                            :
                                                            <DatePicker
                                                                name="paid_leave_end_date"
                                                                //isWeekday={true}
                                                                dateFormat="dd/MM/yyyy"
                                                                placeholder="Tanggal Selesai"
                                                                errorMessage="Masukan Tanggal Selesai"
                                                                excludeDates={this.state.holidays_format_date}
                                                                validate={{ required: { value: true } }}
                                                                defaultValue={this.state.endDate}
                                                                onChange={e => {
                                                                    this.setState({ endDate: moment(e).format('YYYY-MM-DD') });
                                                                    //console.log('Selesai : ' + moment(e).format('YYYY-MM-DD'))
                                                                }}
                                                                minDate={this.state.end_date_min}
                                                                maxDate={this.state.end_date_max}
                                                                //minDate= "2023-03-02"
                                                                //minDate={this.state.minDateSelesai}
                                                                //maxDate={this.state.minDateSelesai}
                                                                selectsRange
                                                                selectsDisabledDaysInRange
                                                                inline
                                                                showDisabledMonthNavigation
                                                             //minDate={this.state.startDate}

                                                             />
                                                }
                                                {/* <AvField
                                                    name="paid_leave_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    onChange={e => { 
                                                        this.setState({ endDate: e.target.value })
                                                    }}
                                                    validate={{ required: { value: true } }}
                                                    min={this.state.minDateSelesai}
                                                    // max={this.state.maxDateSelesai}
                                                /> */}
                                                {this.state.selectedType != '1b490a04a-0362-489b-832a-29e4c3b961bc' &&
                                                    <span className="text-muted">Jumlah cuti diajukan : <strong>{this.state.listCuti?.length}</strong></span>
                                                }
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alasan Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_reason"
                                                    placeholder="Masukkan Alasan Cuti"
                                                    errorMessage="Masukkan Alasan Cuti"
                                                    type="textarea"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alamat Selama Menjalankan Cuti
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_address"
                                                    placeholder="Masukkan Alamat Selama Menjalankan Cuti"
                                                    errorMessage="Masukkan Alamat Selama Menjalankan Cuti"
                                                    type="textarea"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Telepon Selama Cuti
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="paid_leave_phone"
                                                    placeholder="Masukkan No Telepon Selama Cuti"
                                                    errorMessage="Masukkan No Telepon Selama Cuti"
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dokumen Data Pendukung
                                            </Label>
                                            <Col md="4">
                                                <FileInput
                                                    col="6"
                                                    name="document"
                                                    errorMessage="Dokumen Data Pendukung Wajib Diisi"
                                                    validate={{ required: { value: this.state.is_required_file_upload } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                {
                                                    this.state.is_revisi == 1 ?
                                                        <Link to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid}>
                                                            <Button outline color="danger"><i className="uil uil-backward"></i> Kembali</Button>
                                                        </Link>
                                                        :
                                                        <Link to={`/izinpegawai/cuti.html${(this.currentRoleId == 1 ? '?detail_pegawai&uuid=' + this.peg_uuid : '')}`}>
                                                            <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                        </Link>
                                                }
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo={this.state.atasan && this.state.jabatan ? `Data berhasil dikirim ke ${this.state.atasan} - ${this.state.jabatan} ` : "Data berhasil dikirim"}

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedInfo}
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    html={true}
                    response={this.confirmResponse}
                />

                {this.state.redirect && this.state.is_revisi != 1 ?
                    <Redirect to={`/izinpegawai/cuti.html`} />
                    : ""}

                {this.state.redirect && this.state.is_revisi == 1 ?
                    <Redirect to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid} />
                    : ""}

            </Fragment>
        )
    }


}

export default CreateView;